<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="name">
        <span slot="label">
          <a-tooltip>
            {{ $t('姓名') }}<template slot="title"> {{ $t('姓名') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.name" :maxLength="100" :placeholder="$t('请输入')+'姓名/昵称'" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item prop="contactPhone">
        <span slot="label">
          <a-tooltip>
             {{ $t('联系方式') }}
            <template slot="title">  {{ $t('联系方式') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.contactPhone" :maxLength="50" :placeholder="$t('请输入')+$t('联系方式')" :disabled="true" />
      </a-form-model-item>
      <!--      <a-form-model-item prop="contactWay">-->
      <!--        <span slot="label">-->
      <!--          <a-tooltip>-->
      <!--            其他联系方式<template slot="title">其他联系方式</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.contactWay" :maxLength="100" :placeholder="$t('请输入')+'其他联系方式'" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item prop="email">
        <span slot="label">
          <a-tooltip>
               {{ $t('邮箱联系方式') }}
            <template slot="title">  {{ $t('邮箱联系方式') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.email" :maxLength="200" :placeholder="$t('请输入')+'邮箱联系方式'" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item prop="website">
        <span slot="label">
          <a-tooltip>
            {{ $t('网站') }}
            <template slot="title"> {{ $t('网站') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.website" :maxLength="255" :placeholder="$t('请输入')+'网址'" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item prop="instagram">
        <span slot="label">
          <a-tooltip>
            Instagram<template slot="title">Instagram</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.instagram" :maxLength="255" :placeholder="$t('请输入')+'Instagram'" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item prop="tiktok">
        <span slot="label">
          <a-tooltip>
            TikTok<template slot="title">TikTok</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.tiktok" :maxLength="255" :placeholder="$t('请输入')+'TikTok'" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item prop="youtube">
        <span slot="label">
          <a-tooltip>
            YouTube<template slot="title">YouTube</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.youtube" :maxLength="255" :placeholder="$t('请输入')+'YouTube'" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item prop="facebook">
        <span slot="label">
          <a-tooltip>
            Facebook<template slot="title">Facebook</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.facebook" :maxLength="255" :placeholder="$t('请输入')+'Facebook'" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item prop="pinterest">
        <span slot="label">
          <a-tooltip>
            Pinterest<template slot="title">Pinterest</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.pinterest" :maxLength="255" :placeholder="$t('请输入')+'Pinterest'" :disabled="true" />
      </a-form-model-item>
      <!--      <a-form-model-item prop="country">-->
      <!--        <span slot="label">-->
      <!--          <a-tooltip>-->
      <!--            国家<template slot="title">国家</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.country" :maxLength="100" :placeholder="$t('请输入')+'国家'" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item prop="city">-->
      <!--        <span slot="label">-->
      <!--          <a-tooltip>-->
      <!--            城市<template slot="title">城市</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.city" :maxLength="100" :placeholder="$t('请输入')+'城市'" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item prop="remark">
        <span slot="label">
          <a-tooltip>
              {{ $t('备注') }}<template slot="title"> {{ $t('备注') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear :disabled="true" />
      </a-form-model-item>
      <a-form-model-item v-if="form.status===2" prop="processRemark">
        <span slot="label">
          <a-tooltip>
             {{ $t('审核拒绝原因') }}<template slot="title"> {{ $t('审核拒绝原因') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.processRemark" :placeholder="$t('请输入')" type="textarea" allow-clear :disabled="true" />
      </a-form-model-item>
      <a-form-model-item prop="status">
        <span slot="label">
          <a-tooltip>
             {{ $t('审核状态') }}
            <template slot="title"> {{ $t('审核状态') }}</template>
          </a-tooltip>
        </span>
        <span v-if="form.status===0">Pending Review</span>
        <span v-else-if="form.status===1">Approved</span>
        <span v-else-if="form.status===2">Rejected</span>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button v-if="form.status === 0" type="primary" :loading="submitLoading" @click="handlePass">
            {{ $t('审核通过') }}
          </a-button>
          <a-button v-if="form.status === 0" type="danger" :loading="submitLoading" @click="handleRejectShow">
            {{ $t('审核拒绝') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>

    <reject-modal
      :visible="rejectModalVisible"
      :onReject="handleReject"
      @cancel="rejectModalVisible = false"
    />
  </a-drawer>
</template>

<script>
import { getUnionAffiliateApply, addUnionAffiliateApply, updateUnionAffiliateApply, batchRejectUnionAffiliateApply, batchPassUnionAffiliateApply } from '@/api/union/unionAffiliateApply'
import { mapGetters } from 'vuex'
import RejectModal from '@/components/RejectModal/index.vue'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    RejectModal
  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        name: null,

        contactPhone: null,

        contactWay: null,

        email: null,

        website: null,

        instagram: null,

        tiktok: null,

        youtube: null,

        facebook: null,

        pinterest: null,

        country: null,

        city: null,

        remark: null,

        submitTime: null,

        status: 0,

        processRemark: null,

        auditor: null,

        auditTime: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '姓名/昵称' + this.$t('不能为空'), trigger: 'blur' }
        ],
        submitTime: [
          { required: true, message: '提交时间' + this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: '审核状态 0=待审核 1=已通过 2=已拒绝 3=已处理' + this.$t('不能为空'), trigger: 'blur' }
        ]
      },
      rejectModalVisible: false
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        name: null,
        contactPhone: null,
        contactWay: null,
        email: null,
        website: null,
        instagram: null,
        tiktok: null,
        youtube: null,
        facebook: null,
        pinterest: null,
        country: null,
        city: null,
        remark: null,
        submitTime: null,
        status: 0,
        processRemark: null,
        auditor: null,
        auditTime: null
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUnionAffiliateApply({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    handleView(row) {
      this.reset()
      this.formType = 2
      const id = row.id
      getUnionAffiliateApply({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('查看详情')
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateUnionAffiliateApply(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addUnionAffiliateApply(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    async handlePass() {
      this.submitLoading = true
      await batchPassUnionAffiliateApply([this.form.id])
      this.submitLoading = false
      const message = this.$t('审核成功')
      this.$message.success(
        message,
        3
      )
      this.cancel()
      this.$emit('ok')
    },
    async handleReject(reason) {
      this.submitLoading = true
      await batchRejectUnionAffiliateApply({ ids: [this.form.id], reason: reason })
      this.submitLoading = false
      const message = this.$t('拒绝成功')
      this.$message.success(
        message,
        3
      )
      this.cancel()
      this.$emit('ok')
    },
    handleRejectShow() {
      this.rejectModalVisible = true
    }
  }
}
</script>
